import { render, staticRenderFns } from "./KeyLiquidityRatios.vue?vue&type=template&id=73c2939a&scoped=true"
import script from "./KeyLiquidityRatios.vue?vue&type=script&lang=js"
export * from "./KeyLiquidityRatios.vue?vue&type=script&lang=js"
import style0 from "./KeyLiquidityRatios.vue?vue&type=style&index=0&id=73c2939a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c2939a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
